const config = {
  docsURL: 'https://docs.documint.me/integrations/hubspot',
  documintURL: 'https://documint.me',
  inactiveURL: 'https://docs.documint.me/documents/minted-documents',
};

export default config;
